// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { CommonAiSuggestionEvidenceFragment, ReferenceAiOnboardingSuggestionFragment } from '../../graphql/aiSuggestions.generated';
import { gql } from '@apollo/client';
import { CommonAiSuggestionEvidenceFragmentDoc, ReferenceAiOnboardingSuggestionFragmentDoc } from '../../graphql/aiSuggestions.generated';
export type AiOnboardingSuggestionDrawer_KgNodeFragment = { __typename?: 'KGNode', id: string, name: string, mergedFrom?: Array<{ __typename?: 'KGNode', id: string, file?: { __typename?: 'File', id: string, document?: { __typename?: 'Document', id: string } | null } | null }> | null };

export type AiOnboardingSuggestionDrawer_AiSuggestionFragment = { __typename?: 'AISuggestion', id: string, kind: Types.AiSuggestionKind, onboardingIndividual?: { __typename?: 'OnboardingIndividualSuggestion', firstName?: string | null, middleName?: string | null, lastName?: string | null, suffix?: string | null } | null, onboardingOrganization?: { __typename?: 'OnboardingOrganizationSuggestion', displayName?: string | null, organizationName?: string | null } | null, onboardingEntity?: { __typename?: 'OnboardingEntitySuggestion', displayName?: string | null, entityName?: string | null } | null, onboardingTestamentaryEntity?: { __typename?: 'OnboardingTestamentaryEntitySuggestion', displayName?: string | null, testamentaryEntityName?: string | null } | null, asset?: { __typename?: 'AssetSuggestion', assetTitle?: string | null } | null, liability?: { __typename?: 'LiabilitySuggestion', liabilityName?: string | null } | null, file?: { __typename?: 'File', id: string, document?: { __typename?: 'Document', id: string } | null } | null, evidence?: Array<(
    { __typename?: 'AISuggestionEvidence' }
    & CommonAiSuggestionEvidenceFragment
  )> | null, kgNode?: (
    { __typename?: 'KGNode' }
    & AiOnboardingSuggestionDrawer_KgNodeFragment
  ) | null };

export const Operations = {
  Fragment: {
    AIOnboardingSuggestionDrawer_KGNode: 'AIOnboardingSuggestionDrawer_KGNode' as const,
    AIOnboardingSuggestionDrawer_AISuggestion: 'AIOnboardingSuggestionDrawer_AISuggestion' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const AiOnboardingSuggestionDrawer_KgNodeFragmentDoc = gql`
    fragment AIOnboardingSuggestionDrawer_KGNode on KGNode {
  id
  name
  mergedFrom {
    id
    file {
      id
      document {
        id
      }
    }
  }
}
    `;
export const AiOnboardingSuggestionDrawer_AiSuggestionFragmentDoc = gql`
    fragment AIOnboardingSuggestionDrawer_AISuggestion on AISuggestion {
  id
  kind
  onboardingIndividual {
    firstName
    middleName
    lastName
    suffix
  }
  onboardingOrganization {
    displayName
    organizationName
  }
  onboardingEntity {
    displayName
    entityName
  }
  onboardingTestamentaryEntity {
    displayName
    testamentaryEntityName
  }
  asset {
    assetTitle
  }
  liability {
    liabilityName
  }
  file {
    id
    document {
      id
    }
  }
  evidence {
    ...CommonAISuggestionEvidence
  }
  kgNode {
    ...AIOnboardingSuggestionDrawer_KGNode
  }
}
    ${CommonAiSuggestionEvidenceFragmentDoc}
${AiOnboardingSuggestionDrawer_KgNodeFragmentDoc}`;